var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.755 4.62755C11.9863 4.74315 12.2414 4.80333 12.5 4.80333C12.7586 4.80333 13.0137 4.74315 13.245 4.62755L16.2942 3.10255C16.4213 3.03902 16.5626 3.00906 16.7046 3.01553C16.8466 3.02199 16.9845 3.06467 17.1054 3.1395C17.2262 3.21432 17.3259 3.31882 17.395 3.44304C17.4641 3.56726 17.5002 3.70709 17.5 3.84922V14.4859C17.4999 14.6406 17.4568 14.7922 17.3754 14.9238C17.294 15.0554 17.1776 15.1617 17.0392 15.2309L13.245 17.1284C13.0137 17.244 12.7586 17.3042 12.5 17.3042C12.2414 17.3042 11.9863 17.244 11.755 17.1284L8.245 15.3734C8.01367 15.2578 7.75861 15.1976 7.5 15.1976C7.24139 15.1976 6.98634 15.2578 6.755 15.3734L3.70584 16.8984C3.57863 16.962 3.43727 16.9919 3.29522 16.9854C3.15316 16.9789 3.01513 16.9362 2.89427 16.8612C2.7734 16.7863 2.67372 16.6817 2.60471 16.5574C2.5357 16.433 2.49965 16.2931 2.5 16.1509V5.51505C2.50009 5.36034 2.54324 5.2087 2.62463 5.07712C2.70602 4.94554 2.82244 4.83921 2.96084 4.77005L6.755 2.87255C6.98634 2.75696 7.24139 2.69678 7.5 2.69678C7.75861 2.69678 8.01367 2.75696 8.245 2.87255L11.755 4.62755Z",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.80334V17.3033",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.69666V15.1967",
    stroke: "#99A1AF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.98758da7b7b2922a88fc7cf1f63eb0f9.svg";
export { ForwardRef as ReactComponent };